module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=MA - Morocco.b5a4b655.svg";